// extracted by mini-css-extract-plugin
module.exports = {"heading":"Formulario_heading__sN5Ey","buscador":"Formulario_buscador__2ABO4","btn-block":"Formulario_btn-block__C2qiV"};